import { useState } from "react";
import { getPayoutWeekSummary } from "../../../services/api/timekeeping";
import { downloadCsv } from "../../../utils/files/csv";
import {
  buildPayoutWeekSummaryCsv,
  getPayoutWeekSummaryFilename,
} from "./weekSummaryCsv";

/**
 * Fetches one payroll week's worker shifts and downloads the summary CSV.
 *
 * @param {string} weekEnding Week-ending date (YYYY-MM-DD).
 * @returns {{download: Function, isDownloading: boolean, error: string}} Download controls.
 */
export function usePayoutWeekSummaryDownload(weekEnding) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState("");

  /**
   * Load week-summary rows and save them as a CSV in the browser.
   *
   * @returns {Promise<void>}
   */
  const download = async () => {
    if (!weekEnding || isDownloading) {
      return;
    }

    setIsDownloading(true);
    setError("");
    try {
      const payload = await getPayoutWeekSummary(weekEnding);
      const csvText = buildPayoutWeekSummaryCsv(payload);
      downloadCsv(
        getPayoutWeekSummaryFilename(payload.weekEnding || weekEnding),
        csvText
      );
    } catch (downloadError) {
      console.error("Error downloading payout week summary:", downloadError);
      setError("Unable to download week summary.");
    } finally {
      setIsDownloading(false);
    }
  };

  return { download, isDownloading, error };
}
